import styled from 'styled-components';
import { compose, fontSize, fontWeight, letterSpacing, lineHeight, space, textStyle, width } from 'styled-system';
import { typographyAttrs } from '../utils/attrs/typographyAttrs';
import { applyVariations, getPaletteColor } from '../utils/utils';
const nowrap = props => props.nowrap ? {
  whiteSpace: 'nowrap'
} : null;
const accessiblyHide = props => props.hidden ? {
  position: 'absolute',
  width: '1px',
  height: '1px',
  clip: 'rect(1px, 1px, 1px, 1px)'
} : null;
const truncate = props => props.truncate ? {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
} : null;
/**
 * @public
 */
export const Label = /*#__PURE__*/styled.label.attrs(props => ({
  ...typographyAttrs(props),
  ...props
})).withConfig({
  displayName: "Label",
  componentId: "sc-7sa88g-0"
})(["display:block;width:100%;margin:0;z-index:1;color:", ";", " ", " ", " ", " ", " ", " ", ""], getPaletteColor('base'), props => props.bg ? `background-color: ${getPaletteColor(props.bg, 'base')(props)};` : '', props => props.onClick ? 'cursor: pointer;' : '', applyVariations('Label'), nowrap, accessiblyHide, truncate, props => compose(fontSize, fontWeight, lineHeight, letterSpacing, space, textStyle, width)(props));
Label.defaultProps = {
  color: 'text.light',
  textStyle: 'label'
};
Label.displayName = 'Label';
Label.isLabel = true;